if (!window.Eurus.loadedScript.includes('variant-select.js')) {
  window.Eurus.loadedScript.push('variant-select.js');


  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xVariantSelect', (
        element,
        sectionId,
        isProductPage,
        unavailableText,
        productUrl,
        productId,
        showFirstImageAvaiable,
        chooseOption,
        productBundle,
        handleSectionId,
        firstAvailableVariantId,
        pageParam,
        productFeaturedImage,
        quickAddPageParam,
      ) => ({
        variants: null,
        currentVariant: null,
        options: [],
        currentAvailableOptions: [],
        cachedResults: [],
        quickViewSectionId: 'quick-view',
        handleSectionId: sectionId,
        paramVariant: false,
        mediaGallerySource: [],
        isChange: false,
        optionConnects: [],
        mediaOption: "",
        handleSticky: '',
        initfirstMedia: false,
        initialized: false,
        _variantUpdateToken: 0,
        initVariant() {
          this.variants = JSON.parse(this.$el.querySelector('[type="application/json"]').textContent);

          // Initialize options array with default selected values
          this.options = [];
          const checkedInputs = element.querySelectorAll('input[type="radio"]:checked');
          checkedInputs.forEach((input) => {
            const optionPos = parseInt(input.getAttribute('option-pos'));
            const optionIndex = optionPos - 1; // Convert to 0-based index
            if (optionIndex >= 0) {
              this.options[optionIndex] = input.value;
            }
          });

          document.addEventListener(`eurus:product-variant-get:${sectionId}`, (e) => {
            e.detail.callback(this.variants);
          });  
          
          if (chooseOption) {
            this.handleSectionId = 'choose-option';
          }
          if (productBundle) {
            this.handleSectionId = handleSectionId;
          }
          
          if (!productBundle) {
            document.addEventListener('eurus:cart:items-changed', () => {
              this.cachedResults = [];
              Alpine.store('xUpdateVariantQuanity').updateQuantity(sectionId, productUrl, this.currentVariant?.id);
            });
          }

          document.addEventListener('wpd:trade-price-ready', (e) => {
            if (e.detail?.sectionId === sectionId) {
              this._cancelCalculatorPriceTimers();
              this._updateCalculatorPrices();
              this._updateHorizontalOptionPrices();
            }
          });

          document.addEventListener('wpd:calculator-price-synced', (e) => {
            if (e.detail?.sectionId === sectionId) {
              this._cancelCalculatorPriceTimers();
              this._updateCalculatorPrices();
              this._updateHorizontalOptionPrices();
            }
          });



          // Use $nextTick to ensure DOM is ready before setting up watchers and initial calculator visibility
          this.$nextTick(() => {
            // Set initial variant based on selected options
            if (!this._syncCurrentVariantFromHorizontalPicker()) {
              this._updateMasterId();
            }
            // Collection cards may lock a specific variant (bestseller repeats / preselect).
            // Color radios alone can resolve to Single Tile; prefer the locked Box id.
            this._applyLockedMatchingVariant();
            if (this.currentVariant) {
              this._updateVariantInput();
              this._updateProductForms();
            }
            this._ensureInitialVariantForCalculator();
            this._updateHorizontalOptionPrices();
            
            // Initialize variant statuses for proper disabled state on load
            this._updateVariantStatuses();
            
            // Handle calculator visibility on initial load
            if (this.currentVariant) {
              this._handleCalculatorVisibility();
            }

            // Re-run once after the first paint in case option controls initialize later.
            requestAnimationFrame(() => {
              this._ensureInitialVariantForCalculator();
              this._updateHorizontalOptionPrices();
              if (this.currentVariant) this._handleCalculatorVisibility();
            });
            
            this.$watch('options', () => {
              // Keep the click handler light for INP: resolve variant + form id now,
              // defer heavy DOM / section work to the next frame.
              if (!this._syncCurrentVariantFromHorizontalPicker()) {
                this._updateMasterId();
              }
              if (this.currentVariant) {
                this._updateVariantInput();
              }
              requestAnimationFrame(() => {
                this._updateVariantSelector(productFeaturedImage);
              });
            });
          });
        },
        _scheduleAfterNextPaint(fn) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              setTimeout(fn, 0);
            });
          });
        },
        _applyCriticalVariantHtml(html) {
          this._updateQuickAdd(html);
          this._renderPriceProduct(html);
          this._scheduleCalculatorPriceUpdate();
          this._renderProductAvailability(html);
          this._renderSkuProduct(html);
          this._renderProductBadges(html);
          this._renderInventoryStatus(html);
          this._renderInventoryQuantity(html);
          this._renderQuantityPricing(html);
          this._renderBuyButtons(html);
          this._setMessagePreOrder(html);
          this._setPreorderProperties(html);
          this._updateProductCardTitle();
        },
        _applyDeferredVariantHtml(html, { updateMedia = true, mediaOnlyIfChanged = false, quantitySectionId = sectionId } = {}) {
          if (updateMedia) {
            if (mediaOnlyIfChanged) {
              if (showFirstImageAvaiable || this.isChange) {
                this._updateMedia(html);
              }
            } else {
              this._updateMedia(html);
            }
          }
          this._setEstimateDelivery(html);
          this._setMetafieldInfo(html, '.properties_re_render');
          this._setMetafieldInfo(html, '.table_info_details');
          this._setMetafieldInfo(html, '.block-text');
          this._setMetafieldInfo(html, '.text-icon');
          this._setMetafieldInfo(html, '.collapsible-content');
          this._setMetafieldInfo(html, '.nutrition-bar-content');
          this._setMetafieldInfo(html, '.horizontab');
          this._setMetafieldInfo(html, '.featured-icon');
          this._updateSameColorDifferentSize(html);
          this._setCartEstimateDelivery(html);
          this._setBackInStockAlert(html);
          this._setPickupPreOrder(html);
          if (!productBundle) {
            Alpine.store('xUpdateVariantQuanity').render(html, quantitySectionId);
          }
        },
        initCalculatorVisibilityFromSelectedVariant() {
          this.$nextTick(() => {
            if (!this.currentVariant) {
              const selectedVariantScript = this.$el.querySelector('script[type="application/json"][data-selected-variant]');
              if (selectedVariantScript?.textContent) {
                try {
                  this.currentVariant = JSON.parse(selectedVariantScript.textContent);
                } catch (error) {
                  // Ignore malformed inline JSON and keep current behavior.
                }
              }
            }

            if (this.currentVariant) {
              this._handleCalculatorVisibility();
            }
          });
        },
        initMedia(init) {
          if (init) {
            this.initfirstMedia = true;
          }
          this._updateMasterId();
          this._updateMedia();
          this.initfirstMedia = false;
        },
        _updateVariantSelector(productFeaturedImage = "") {
          const updateToken = ++this._variantUpdateToken;

          this._updateMasterId();
          this._updateVariantStatuses();
          this._updateOptionImage();
          this._updateHorizontalOptionPrices();
          
          if (!this.currentVariant) {
            this._dispatchUpdateVariant();
            this._setUnavailable();
            return;
          }
          if (firstAvailableVariantId != this.currentVariant.id) {
            this.paramVariant = true;
          }
          if (isProductPage && this.paramVariant) {
            window.history.replaceState({}, '', `?variant=${this.currentVariant.id}`);
          }
          if (chooseOption == '' && !isProductPage) {
            this._updateImageVariant(productFeaturedImage);
          }
          if(quickAddPageParam){
            this._updateImageVariant(productFeaturedImage);
          }
          this._updateVariantInput();
          this._updateProductForms();
          this._setAvailable();
          this._updateProductCardTitle();

          // Visible purchase UI first; pickup / metafields / gallery after paint.
          this._handleCalculatorVisibility();
          this._resetQuantitySelector();

          const cacheKey = sectionId + '-' + this.currentVariant.id;
          const finishCritical = (html, { dispatchWithHtml = false, mediaOnlyIfChanged = false } = {}) => {
            if (updateToken !== this._variantUpdateToken) return;
            this._applyCriticalVariantHtml(html);
            if (dispatchWithHtml) {
              this._dispatchUpdateVariant(html);
            } else {
              this._dispatchUpdateVariant();
            }
            this._scheduleAfterNextPaint(() => {
              if (updateToken !== this._variantUpdateToken) return;
              this._applyDeferredVariantHtml(html, { mediaOnlyIfChanged });
              Alpine.store('xPickupAvailable').updatePickUp(sectionId, this.currentVariant?.id);
              this._dispatchVariantSelected(html);
            });
          };

          if (this.cachedResults[cacheKey]) {
            finishCritical(this.cachedResults[cacheKey]);
          } else {
            const variantId = this.currentVariant.id;
            let url = chooseOption?`${productUrl}?variant=${variantId}&section_id=${this.handleSectionId}&page=${pageParam ? pageParam : quickAddPageParam}`:`${productUrl}?variant=${variantId}&section_id=${this.handleSectionId}`
            fetch(url)
              .then((response) => response.text())
              .then((responseText) => {
                if (updateToken !== this._variantUpdateToken) return;
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                if (this.currentVariant && variantId == this.currentVariant.id
                  && html.getElementById(`x-product-template-${productId}-${sectionId}`)) {
                  this.cachedResults[cacheKey] = html;
                  finishCritical(html, { dispatchWithHtml: true, mediaOnlyIfChanged: true });
                } else if (this.currentVariant && variantId == this.currentVariant.id) {
                  this._renderPriceProduct(html);
                  this._scheduleCalculatorPriceUpdate();
                  this._updateProductCardTitle();
                  this._dispatchUpdateVariant(html);
                }
              });
          }
        },
        _dispatchVariantSelected(html) {
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select:updated:${sectionId}`, {
            detail: {
              currentVariantStatus: this.currentVariant?.available,
              currentAvailableOptions: this.currentAvailableOptions,
              options: this.options,
              html: html
            }
          }));

          // Update buy-with section
          this._updateBuyWithSection();
        },
        _updateBuyWithSection() {
          const buyWithSection = document.getElementById('buywith-section');
          if (!buyWithSection) return;

          const variantContents = buyWithSection.querySelectorAll('.buywith-variant-content');
          if (variantContents.length === 0) return;

          let hasVisibleContent = false;
          const currentVariantId = this.currentVariant?.id;

          variantContents.forEach(content => {
            if (content.dataset.variantId == currentVariantId) {
              content.style.display = 'block';
              hasVisibleContent = true;
            } else {
              content.style.display = 'none';
            }
          });

          buyWithSection.style.display = hasVisibleContent ? 'block' : 'none';
        },
        _updateVariantStatuses() {
          // Initialize currentAvailableOptions for all option positions
          this.currentAvailableOptions = [];
          
          // For each option position, determine which values are available
          const maxOptions = Math.max(...this.variants.map(v => [v.option1, v.option2, v.option3].filter(Boolean).length));
          
          for (let optionIndex = 0; optionIndex < maxOptions; optionIndex++) {
            this.currentAvailableOptions[optionIndex] = [];
            
            if (optionIndex === 0) {
              // For first option, any available variant makes that option available
              this.variants.forEach(variant => {
                const optionValue = this._decodeOptionValue(variant.option1);
                if (variant.available && optionValue && !this.currentAvailableOptions[optionIndex].includes(optionValue)) {
                  this.currentAvailableOptions[optionIndex].push(optionValue);
                }
              });
            } else {
              // For subsequent options, if no previous options are selected yet (initial load),
              // show all available options
              const selectedPreviousOptions = this.options.slice(0, optionIndex);
              const hasValidPreviousSelections = selectedPreviousOptions.some(opt => opt && opt !== undefined);
              
              if (!hasValidPreviousSelections) {
                // On initial load, show all available options for this position
                this.variants.forEach(variant => {
                  if (!variant.available) return;
                  
                  const optionValue = this._decodeOptionValue(variant[`option${optionIndex + 1}`]);
                  if (optionValue && !this.currentAvailableOptions[optionIndex].includes(optionValue)) {
                    this.currentAvailableOptions[optionIndex].push(optionValue);
                  }
                });
              } else {
                // Normal filtering based on previous selections
                this.variants.forEach(variant => {
                  if (!variant.available) return;
                  
                  const optionValue = this._decodeOptionValue(variant[`option${optionIndex + 1}`]);
                  if (!optionValue) return;
                  
                  // Check if this variant matches all previously selected options
                  let matchesPrevious = true;
                  for (let prevIndex = 0; prevIndex < selectedPreviousOptions.length; prevIndex++) {
                    const selectedValue = selectedPreviousOptions[prevIndex];
                    const variantValue = this._decodeOptionValue(variant[`option${prevIndex + 1}`]);
                    if (selectedValue && variantValue !== selectedValue) {
                      matchesPrevious = false;
                      break;
                    }
                  }
                  
                  if (matchesPrevious && !this.currentAvailableOptions[optionIndex].includes(optionValue)) {
                    this.currentAvailableOptions[optionIndex].push(optionValue);
                  }
                });
              }
            }
          }
        },
        _decodeOptionValue(option) {
          if (option) {
            return option
                    .replaceAll('\\/', '/');
          }
        },
        _renderInventoryStatus(html) {
          const destination = document.getElementById('block-inventory-' + sectionId);
          const source = html.getElementById('block-inventory-' + sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _renderInventoryQuantity(html) {
          const destination = document.getElementById('block-available-quantity-' + sectionId);
          const source = html.getElementById('block-available-quantity-' + sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _renderQuantityPricing(html) {
          const destinationQtyRules = document.getElementById('quantity-selector-' + sectionId);
          const destinationQtyPricing = document.getElementById('volume-' + sectionId);
          const sourceQtyRules = html.getElementById('quantity-selector-' + sectionId);
          const sourceQtyPricing = html.getElementById('volume-' + sectionId);

          if(destinationQtyRules && sourceQtyRules) {
            destinationQtyRules.innerHTML = sourceQtyRules.innerHTML;
          }
          if(destinationQtyPricing && sourceQtyPricing){
            destinationQtyPricing.innerHTML = sourceQtyPricing.innerHTML;
          }
        },
        _updateQuickAdd(html){
            const listCurrent = document.querySelectorAll(`#product-form-choose-option${productId}${quickAddPageParam}`);
            const destination = html.querySelector(`#product-form-choose-option${productId}${quickAddPageParam}`);
            if(listCurrent.length>0 && destination){
              listCurrent.forEach((item)=>{
                item.innerHTML = destination.innerHTML;
                const currentPrice = item.closest('.card-product').querySelector(".main-product-price");
                const updatePrice = html.querySelector(".main-product-price");
                if(currentPrice && updatePrice){
                  currentPrice.innerHTML = updatePrice.innerHTML
                }
              })
            }
        },
        _updateMedia(html) {
          let mediaWithVariantSelected = document.getElementById("product-media-" + sectionId) && document.getElementById("product-media-" + sectionId).dataset.mediaWithVariantSelected;
          
          if (!chooseOption && !productBundle && !mediaWithVariantSelected) {
            let splideEl = document.getElementById("x-product-" + sectionId);
            let slideVariant = ""
            let index = ""
            let activeEL = ""
            if (this.currentVariant && this.currentVariant.featured_media != null) {
              slideVariant = document.getElementsByClassName(this.currentVariant.featured_media.id + '-' + sectionId);
              index = parseInt(slideVariant[0]?.getAttribute('index'));
              activeEL = document.getElementById('postion-image-' + sectionId + '-' + this.currentVariant.featured_media.id);
            } else {
              slideVariant = splideEl.querySelector(".featured-image");
              index = parseInt(slideVariant?.getAttribute('index'));
              activeEL = document.querySelector(`#stacked-${sectionId} .featured-image`);
            }
            
            if (splideEl) {
              if (splideEl.splide && slideVariant) {
                splideEl.splide.go(index)
              } else {
                document.addEventListener(`eurus:media-gallery-ready:${sectionId}`, () => {
                  if (splideEl.splide)
                    splideEl.splide.go(index);
                });
              }
            }
            if (!activeEL) return;
            

            if (html && !mediaWithVariantSelected) {
              let mediaGalleryDestination = html.getElementById(`stacked-${ sectionId }`);
              let mediaGallerySource = document.getElementById(`stacked-${ sectionId }`);

              if (mediaGallerySource && mediaGalleryDestination) {
                let firstChildSource = mediaGallerySource.querySelectorAll('div[data-media-id]')[0];
                let firstChildDestination = mediaGalleryDestination.querySelectorAll('div[data-media-id]')[0];
                if (firstChildDestination.dataset.mediaId != firstChildSource.dataset.mediaId && firstChildSource.dataset.index != 1) {
                  let sourceIndex = parseInt(firstChildSource.dataset.index);  
                  let positionOld = mediaGallerySource.querySelector(`div[data-media-id]:nth-of-type(${sourceIndex + 1})`);
                  mediaGallerySource.insertBefore(firstChildSource, positionOld);
                }

                mediaGallerySource.prepend(activeEL);
              }
            }
          }
          if (mediaWithVariantSelected) {
            this.updateMultiMediaWithVariant();
          }
        },
        _updateColorSwatch(html) {
          const showSwatchWithVariantImage = document.querySelector(`#variant-update-${ sectionId }`).dataset.showSwatchWithVariantImage;
          const destination = document.querySelector(`#variant-update-${ sectionId } [data-swatch="true"]`);
          if(destination && showSwatchWithVariantImage) {
            const source = html.querySelector(`#variant-update-${ sectionId } [data-swatch="true"]`);
            if (source) destination.innerHTML = source.innerHTML;
          }
        },
        _validateOption() {
          const mediaWithOption = document.querySelector(`#shopify-section-${sectionId} [data-media-option]`);
          if (mediaWithOption)
            this.mediaOption = mediaWithOption.dataset.mediaOption.split('_');
        },
        updateMultiMediaWithVariant() {
          this._validateOption();
          if (!this.currentVariant) {
            if (this.initfirstMedia) {
              let productMedia = document.querySelectorAll( `#ProductModal-${ sectionId } [data-media-option], #shopify-section-${ sectionId } [data-media-option]`);
              Array.from(productMedia).reverse().forEach(function(newMedia) {
                newMedia.classList.add('media_active');
                if (newMedia.classList.contains('media-slide')) {
                  newMedia.classList.add('splide__slide');
                }
              });
            }
            return;
          }
          const variantInputs = this.mediaOption.map(option =>
            document.querySelector(`#shopify-section-${sectionId} [data-option-name="${option}"]`)
          ).filter(el => el !== null);
          if (variantInputs.length === 0) {
            let variantMedias = ""
            if (!this.currentVariant.featured_media?.id) {
              variantMedias = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-option].featured-image, #shopify-section-${ sectionId } [data-media-option].featured-image`); 
            } else {
              variantMedias = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-option="${sectionId}-${this.currentVariant.featured_media.id}"], #shopify-section-${ sectionId } [data-media-option="${sectionId}-${this.currentVariant.featured_media.id}"]`);
            }
            let mediaActive = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-option=""], #shopify-section-${ sectionId } [data-media-option=""]`);
            let productMedias = document.querySelectorAll( `#ProductModal-${ sectionId } [data-media-option], #shopify-section-${ sectionId } [data-media-option]`);
            const newMedias = Array.prototype.concat.call( ...mediaActive, ...variantMedias)
            this._setActiveMedia(productMedias, newMedias, variantMedias);

            let splideEl = document.getElementById(`x-product-${ sectionId }`);
            if (splideEl && splideEl.splide) {
              splideEl.splide.refresh();
              splideEl.splide.go(0);
            }
            let splideZoomEl = document.getElementById(`media-gallery-${ sectionId }`);
            if (splideZoomEl && splideZoomEl.splide) {
              splideZoomEl.splide.refresh();
            }
            if (typeof window.xProductMediaCount?.[sectionId] === 'function') {
              requestAnimationFrame(() => window.xProductMediaCount[sectionId](0));
            }
          } else {
            let optionConnects = [];
            variantInputs.forEach((variantInput) => {
              const variantOptionIndex = variantInput && variantInput.dataset.optionIndex;
              const optionValue = this._handleText(this.currentVariant[`option${parseInt(variantOptionIndex) + 1}`]);
              if (this.mediaOption.includes(variantInput.dataset.optionName)) {
                optionConnects.push(variantInput.dataset.optionName + '-' + optionValue);
              }
              this.optionIndex = variantOptionIndex;
            });
            const mediaActive = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-type=""], #shopify-section-${ sectionId } [data-media-type=""]`);
            
            let variantMedias = [];
            let allVariantMedias = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-type]:not([data-media-type=""]), #shopify-section-${ sectionId } [data-media-type]:not([data-media-type=""])`);
            allVariantMedias.forEach((variantMedia) => {
              let data = variantMedia.getAttribute('data-media-type');
              let dataSet = new Set(data.split('_'));
              if (optionConnects.filter(option => dataSet.has(option)).length === dataSet.size) variantMedias.push(variantMedia);
            });

            let showFeatured = false;
            if (!variantMedias.length) {
              if (!this.currentVariant.featured_media?.id) {
                variantMedias = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-option].featured-image, #shopify-section-${ sectionId } [data-media-option].featured-image`); 
                showFeatured = true;
              } else {
                variantMedias = document.querySelectorAll(`#ProductModal-${ sectionId } [data-media-id="${sectionId}-${this.currentVariant.featured_media.id}"], #shopify-section-${ sectionId } [data-media-id="${sectionId}-${this.currentVariant.featured_media.id}"]`);
              }
            }
            if (!variantMedias.length) {
              document.querySelectorAll( `#ProductModal-${ sectionId } [data-media-type], #shopify-section-${ sectionId } [data-media-type]`).forEach(function(media){
                media.classList.add('media_active');
                media.classList.add('splide__slide');
              });
              let splideEl = document.getElementById(`x-product-${ sectionId }`);
              if (splideEl.splide) {
                splideEl.splide.refresh();
                splideEl.splide.go(0);
              }
              let splideZoomEl = document.getElementById(`media-gallery-${ sectionId }`);
              if (splideZoomEl.splide) {
                splideZoomEl.splide.refresh();
              }
              if (typeof window.xProductMediaCount?.[sectionId] === 'function') {
                requestAnimationFrame(() => window.xProductMediaCount[sectionId](0));
              }
              return;
            }
            
            const newMedias = Array.prototype.concat.call(...variantMedias , ...mediaActive);
            let productMedias = document.querySelectorAll( `#shopify-section-${ sectionId } [data-media-type], #ProductModal-${ sectionId } [data-media-type]`);
            
            // Find the featured media element in the variant medias to pass as activeMedia
            let featuredMediaElement = null;
            if (this.currentVariant.featured_media?.id) {
              const expectedMediaId = `${sectionId}-${this.currentVariant.featured_media.id}`;
              
              featuredMediaElement = Array.from(variantMedias).find(media => 
                media.dataset?.mediaId === expectedMediaId
              );
              
              // Check if we found a thumbnail instead of main gallery element
              if (featuredMediaElement && featuredMediaElement.classList.contains('media-thumbnail')) {
                // Look for the main gallery element with the same media ID
                const mainGalleryElement = document.querySelector(`#stacked-${sectionId} [data-media-id="${expectedMediaId}"]`);
                if (mainGalleryElement) {
                  featuredMediaElement = mainGalleryElement;
                }
              }
            }
            
            this._setActiveMedia(productMedias, newMedias, featuredMediaElement);
            
            if (this.optionConnect != optionConnects) {
              this.optionConnect = optionConnects;
            }
            
            let splideEl = document.getElementById(`x-product-${ sectionId }`);
            if (splideEl.splide) {
              splideEl.splide.refresh();
              splideEl.splide.go(0);
            }
            let splideZoomEl = document.getElementById(`media-gallery-${ sectionId }`);
            if(splideZoomEl && splideZoomEl.splide){
              splideZoomEl.splide.refresh();
            }
            if (typeof window.xProductMediaCount?.[sectionId] === 'function') {
              requestAnimationFrame(() => window.xProductMediaCount[sectionId](0));
            }
            
            if (showFeatured) {
              this._goToFirstSlide();
            }  
          }
        },
        _ensureFeaturedMediaPosition(activeMedia) {
          const stackedContainer = document.getElementById(`stacked-${sectionId}`);
          if (!stackedContainer || !activeMedia) return;

          // Cache the media ID to avoid repeated property access
          const targetMediaId = activeMedia.dataset?.mediaId;
          if (!targetMediaId) return;

          let isProcessing = false;

          // Create a MutationObserver to watch for DOM changes that might revert our positioning
          const observer = new MutationObserver(() => {
            // Debounce: skip if already processing
            if (isProcessing) return;
            isProcessing = true;

            requestAnimationFrame(() => {
              // Quick check: only verify first child instead of querying all active elements
              const firstChild = stackedContainer.firstElementChild;
              if (firstChild?.dataset?.mediaId !== targetMediaId) {
                // Our featured media was moved - restore it to first position
                // Use cached reference instead of querySelector if possible
                if (activeMedia.parentElement === stackedContainer) {
                  stackedContainer.prepend(activeMedia);
                } else {
                  // Fallback: element might have been cloned/replaced
                  const featuredElement = stackedContainer.querySelector(`[data-media-id="${targetMediaId}"]`);
                  if (featuredElement) {
                    stackedContainer.prepend(featuredElement);
                  }
                }
              }
              isProcessing = false;
            });
          });

          // Start observing with minimal configuration for performance
          observer.observe(stackedContainer, {
            childList: true,
            subtree: false
          });

          // Stop observing after a shorter time since mutations should happen quickly
          setTimeout(() => {
            observer.disconnect();
          }, 500);
        },
        _setActiveMedia(productMedias, newMedias, activeMedia) {
          // Clear all media states
          productMedias.forEach(function(media){
            media.classList.remove('media_active');
            media.classList.remove('splide__slide');
            media.classList.remove('x-thumbnail');
          });
          
          // Apply filtering as normal
          Array.from(newMedias).reverse().forEach(function(newMedia) {
            newMedia.classList.add('media_active');
            if (newMedia.classList.contains('media-thumbnail')) {
              newMedia.classList.add('x-thumbnail');
            }
            if (newMedia.classList.contains('media-slide')) {
              newMedia.classList.add('splide__slide');
            }
            let parent = newMedia.parentElement;
            if (activeMedia) {
              if (parent.firstChild != newMedia && Array.from(activeMedia).includes(newMedia)) {
                parent.prepend(newMedia);
              }
            } else {
              if (parent.firstChild != newMedia) {
                parent.prepend(newMedia);
              }
            }
          });

          if (activeMedia) {
            let parent = activeMedia.parentElement;
            parent && parent.prepend(activeMedia);
            
            // Use MutationObserver to efficiently detect and correct DOM changes
            this._ensureFeaturedMediaPosition(activeMedia);
          }

          // Post-filtering: Limit stacked items (even count so 50% pairs fill each row), move excess to thumbnails
          const STACKED_MEDIA_LIMIT = 6;
          const stackedContainer = document.getElementById(`stacked-${sectionId}`);
          const thumbnailContainer = document.getElementById(`x-product-thumbnail-${sectionId}`);
          
          if (stackedContainer) {
            if (thumbnailContainer) {
              // First, clear all thumbnail states
              const allThumbnails = thumbnailContainer.querySelectorAll('[data-media-id]');
              allThumbnails.forEach(thumb => {
                thumb.classList.remove('x-thumbnail', 'media_active');
                thumb.style.opacity = '0.3';
              });
              
              const activeElements = stackedContainer.querySelectorAll('.product-media-item.media_active');
              
              // If we have more than the stacked limit, move excess to thumbnails
              if (activeElements.length > STACKED_MEDIA_LIMIT) {
                const excessElements = Array.from(activeElements).slice(STACKED_MEDIA_LIMIT);
                
                excessElements.forEach(media => {
                  // Remove from stacked container classes
                  media.classList.remove('media_active', 'splide__slide');
                  media.style.display = 'none';
                  
                  // Find corresponding thumbnail and activate it
                  const mediaId = media.dataset.mediaId;
                  if (mediaId) {
                    const thumbnail = thumbnailContainer.querySelector(`[data-media-id="${mediaId}"]`);
                    if (thumbnail) {
                      thumbnail.classList.add('x-thumbnail', 'media_active');
                      thumbnail.style.display = '';
                      thumbnail.style.opacity = '1';
                    }
                  }
                });
                
                // Show thumbnail container with desktop-only CSS classes
                const activeThumbnails = thumbnailContainer.querySelectorAll('.media_active');
                if (activeThumbnails.length > 0) {
                  // Remove any inline styles that might override Tailwind
                  thumbnailContainer.style.display = '';
                  thumbnailContainer.style.visibility = '';
                  // Use Tailwind classes for desktop-only visibility
                  thumbnailContainer.classList.remove('hidden');
                  thumbnailContainer.classList.add('hidden', 'lg:block');
                }
              } else {
                // Hide thumbnail container if no excess images
                thumbnailContainer.style.display = '';
                thumbnailContainer.style.visibility = '';
                thumbnailContainer.classList.add('hidden');
                thumbnailContainer.classList.remove('lg:block');
              }
            }

            // Full-width centered image when only one media is visible for this variant
            const visibleStacked = stackedContainer.querySelectorAll('.product-media-item.media_active');
            const unfilteredItems = stackedContainer.querySelectorAll('.product-media-item:not([data-media-option])');
            const visibleCount = visibleStacked.length > 0
              ? visibleStacked.length
              : unfilteredItems.length;
            stackedContainer.classList.toggle('is-single-media', visibleCount === 1);
          }

          // Sync mobile counter + arrows to the active variant slide count
          if (typeof window.xProductMediaCount?.[sectionId] === 'function') {
            requestAnimationFrame(() => window.xProductMediaCount[sectionId](0));
          }
        },
        // _handleText(someString) {
        //   if (someString) {
        //     return someString.toString().replace('ı', 'i').replace('ß', 'ss').normalize('NFC').replace('-', ' ').toLowerCase().trim().replace(/[^\p{L}\p{N}\s-]/gu, '').replace(/\s+/g, "-");
        //   }
        // },
        _handleText(someString) {
          if (!someString) return '';

          return someString.toString()
            .trim()
            .normalize('NFC')
            // Convert common fractions
            .replace(/½/g, '1-2')
            .replace(/¼/g, '1-4')
            .replace(/¾/g, '3-4')
            .replace(/⅛/g, '1-8')
            .replace(/⅜/g, '3-8')
            .replace(/⅝/g, '5-8')
            .replace(/⅞/g, '7-8')
            // Replace any remaining slashes in fractions (fallback)
            .replace(/\/(\d)/g, '-$1')
            // Clean up quotes and special chars
            .replace(/["'’]/g, '')
            // Normalize dashes and spaces
            .replace(/\s*-\s*/g, '-')
            .replace(/\s+/g, '-')
            .toLowerCase()
            // Remove any remaining unsafe chars except letters, numbers, hyphens
            .replace(/[^a-z0-9-]/g, '')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '');
        },
        _goToFirstSlide() {
          if (this.currentVariant && !this.currentVariant.featured_image) {
            let splideEl = document.getElementById("x-product-" + sectionId);
            if (splideEl) {
              if (splideEl.splide && this.currentVariant && this.currentVariant.featured_image != null) {
                splideEl.splide.go(0);
              }
            }

            let activeEL = document.querySelector(`#stacked-${sectionId} .featured-image`);
            let stackedEL = document.getElementById('stacked-' + sectionId);
            if(stackedEL && activeEL) stackedEL.prepend(activeEL);
          }
        },
        _getSwatchImageUrl(src, size = 128) {
          if (!src) return src;
          let url = src
            .replace(/([?&])width=\d+/g, '$1')
            .replace(/([?&])height=\d+/g, '$1')
            .replace(/([?&])crop=[^&]*/g, '$1')
            .replace(/\?&/, '?')
            .replace(/[?&]$/, '')
            .replace(/\?$/, '');
          return `${url}${url.includes('?') ? '&' : '?'}width=${size}&height=${size}&crop=center`;
        },
        _normalizeSwatchBg(value) {
          if (!value) return '';
          const raw = value.replace(/^url\((['"]?)(.*)\1\)$/, '$2');
          try {
            const full = raw.startsWith('//') ? `https:${raw}` : raw;
            const parsed = new URL(full);
            return `${parsed.pathname}|${parsed.searchParams.get('width') || ''}|${parsed.searchParams.get('height') || ''}`;
          } catch {
            return raw;
          }
        },
        onChange(el, src, isColor = false) {
          if (!this.isChange) {
            this.isChange = this.$el.parentNode.dataset.optionName;
          }

          if (isColor) return;

          const swatchesContainer = el.closest('.options-container');
          if (!swatchesContainer) return;

          const swatches = swatchesContainer.querySelectorAll('label.color-watches');
          if (!swatches.length) return;

          const inputs = swatchesContainer.querySelectorAll('input:checked');
          const selectedOption = [];

          inputs.forEach(input => {
            if (![...swatches].some(swatch => swatch.dataset.optionvalue === input.value)) {
              selectedOption.push(input.value);
            }
          });

          // Color-only: Liquid already set correct --bg-image; skip to avoid double-fetch.
          // Multi-option (e.g. Size): sync swatch images to the selected non-color options.
          if (!selectedOption.length) return;

          const variantSrc = this.variants.reduce((acc, variant) => {
            if (variant.featured_image) {
              acc[variant.id] = this._getSwatchImageUrl(variant.featured_image.src);
            }
            return acc;
          }, {});

          const imageSrc = this.variants
            .filter(variant => selectedOption.every(option =>
              variant.option1 === option || variant.option2 === option || variant.option3 === option
            ))
            .map(variant => `url(${variantSrc[variant.id] ? variantSrc[variant.id] : this._getSwatchImageUrl(src)})`);

          swatches.forEach((swatch, index) => {
            const next = imageSrc[index];
            if (!next) return;
            if (this._normalizeSwatchBg(swatch.style.getPropertyValue('--bg-image')) === this._normalizeSwatchBg(next)) return;
            swatch.style.setProperty('--bg-image', next);
          });
        },
        _normalizeOption(value) {
          return value
            ?.toString()
            .trim()
            .replace(/&quot;/g, '"')
            .normalize('NFKC');
        },
        _ensureInitialVariantForCalculator() {
          if (!this.variants?.length) return;

          const variantFromUrl = new URLSearchParams(window.location.search).get('variant');
          const variantInput = document.querySelector(`#product-form-${sectionId} [name="id"]`);
          const variantFromInput = variantInput?.value;
          const variantId = variantFromUrl || variantFromInput;

          if (!variantId) return;

          const matchedVariant = this.variants.find((variant) => String(variant.id) === String(variantId));
          if (matchedVariant) {
            this.currentVariant = matchedVariant;
          }
        },
        _applyLockedMatchingVariant() {
          const card = element.closest?.('.card-product');
          if (!card || card.dataset.variantLocked !== 'true') return;
          const lockedId = card.dataset.matchingVariant;
          if (!lockedId || lockedId === 'none' || !this.variants?.length) return;
          const locked = this.variants.find((v) => String(v.id) === String(lockedId));
          if (!locked) return;
          this.currentVariant = locked;
          const currentVariantEl = card.querySelector('.current-variant');
          if (currentVariantEl) currentVariantEl.textContent = lockedId;
        },

        _updateMasterId() {
          // On initial load, option controls may not be fully initialized yet.
          // Keep variant from URL/form input to avoid temporary box auto-selection.
          const hasSelectedOptions = Array.isArray(this.options) && this.options.some((option) => !!this._normalizeOption(option));
          if (!hasSelectedOptions) {
            this._ensureInitialVariantForCalculator();
            this._applyLockedMatchingVariant();
            return;
          }

          // Find all variants that match the selected options
          const matchingVariants = this.variants.filter((variant) => {
            return !this.options.map((option, index) => {
              const variantOption = variant[`option${index + 1}`];

              return (
                this._normalizeOption(option) ===
                this._normalizeOption(variantOption)
              );
            }).includes(false);
          });

          if (matchingVariants.length === 0) {
            this.currentVariant = null;
            return;
          }

          if (matchingVariants.length === 1) {
            this.currentVariant = matchingVariants[0];
            return;
          }

          const selectedSampleOption = this.options.some((option) => {
            const value = String(option || '').toLowerCase();
            return (
              value.includes('sample') ||
              value.includes('single tile') ||
              value.includes('single sheet') ||
              value.includes('single product')
            );
          });

          if (selectedSampleOption) {
            const sampleVariants = matchingVariants.filter((variant) => this._isSampleVariant(variant));
            if (sampleVariants.length > 0) {
              const availableSampleVariants = sampleVariants.filter((variant) => variant.available);
              this.currentVariant = availableSampleVariants.length > 0 ? availableSampleVariants[0] : sampleVariants[0];
              return;
            }
          }

          // If multiple variants match, prioritize box variants
          const boxVariants = matchingVariants.filter((variant) => {
            return this._isBoxVariant(variant);
          });

          if (boxVariants.length > 0) {
            // Prioritize available box variants to keep calculator-visible variants selected.
            const availableBoxVariants = boxVariants.filter((variant) => variant.available);
            this.currentVariant = availableBoxVariants.length > 0 ? availableBoxVariants[0] : boxVariants[0];
          } else {
            // No box variants found, use the first matching variant.
            this.currentVariant = matchingVariants[0];
          }

          // If still on the locked color, keep the Liquid-selected variant id.
          const card = element.closest?.('.card-product');
          if (card?.dataset?.variantLocked === 'true') {
            const lockedId = card.dataset.matchingVariant;
            const locked = this.variants.find((v) => String(v.id) === String(lockedId));
            if (
              locked &&
              this.currentVariant &&
              locked.option1 === this.currentVariant.option1
            ) {
              this.currentVariant = locked;
            }
          }
        },

        _updateHorizontalOptionPrices() {
          const labels = this.$el.querySelectorAll('.variant-option-label--horizontal');
          if (!labels.length || !this.variants?.length) return;

          const sectionRoot = document.getElementById(`shopify-section-${sectionId}`) || this.$el;
          const mainPriceEl = this._getMainPriceElement(sectionRoot);
          const mainVariantId = mainPriceEl?.getAttribute('data-wpd-variant-id');
          const mainHasWpd = Boolean(
            mainPriceEl?.classList?.contains('wpd-processed')
            || mainPriceEl?.querySelector?.('.wpd-processed')
          );
          const selectedByPos = {};
          this.$el.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
            const pos = parseInt(input.getAttribute('option-pos'), 10);
            if (pos) selectedByPos[pos] = input.value;
          });

          labels.forEach((label) => {
            const input = document.getElementById(label.getAttribute('for'));
            if (!input) return;
            const pos = parseInt(input.getAttribute('option-pos'), 10);
            const value = input.value;

            const match = this.variants.find((variant) => {
              for (let p = 1; p <= 3; p += 1) {
                const variantOpt = variant[`option${p}`];
                if (!variantOpt) continue;
                const expected = p === pos ? value : selectedByPos[p];
                if (!expected) continue;
                if (this._normalizeOption(variantOpt) !== this._normalizeOption(expected)) return false;
              }
              return true;
            });

            if (!match) return;

            label.dataset.variantId = String(match.id);

            const priceEl = label.querySelector('.js-option-price');
            const sqftEl = label.querySelector('.js-option-sqft-price');
            const isSelected = this.currentVariant && String(this.currentVariant.id) === String(match.id);
            const mainMatchesOption = Boolean(mainVariantId && String(mainVariantId) === String(match.id));
            const optionHasWpd = Boolean(priceEl?.classList?.contains('wpd-processed'));
            const canSyncFromMain = isSelected && mainMatchesOption && (!optionHasWpd || mainHasWpd);
            const priceCents = this._getOptionDisplayPriceCents(match, priceEl, sectionRoot, canSyncFromMain);

            if (priceEl && priceCents > 0) {
              if (canSyncFromMain) {
                const mainText = this._getMainPriceText(sectionRoot);
                const mainCompareText = this._getMainCompareText(sectionRoot);
                this._setOptionBoxPrice(priceEl, mainText || this._formatMoney(priceCents), mainCompareText);
              } else if (!isSelected) {
                const compareCents = this._getOptionDisplayCompareCents(match, priceEl, sectionRoot, false);
                const compareText = compareCents > priceCents ? this._formatMoney(compareCents) : '';
                this._setOptionBoxPrice(priceEl, this._formatMoney(priceCents), compareText);
              }
            }

            if (!sqftEl) return;
            const area = parseFloat(label.dataset.sqftArea);
            if (!(area > 0) || !(priceCents > 0)) return;

            if (canSyncFromMain) {
              const mainSqft = this._getMainSqftText(sectionRoot);
              const mainSqftCompare = this._getMainSqftCompareText(sectionRoot);
              if (mainSqft) {
                this._setOptionSqftText(sqftEl, mainSqft, mainSqftCompare);
                return;
              }
            }

            if (isSelected && !canSyncFromMain) return;

            const perSqftCents = Math.round(priceCents / area);
            const compareCents = this._getOptionDisplayCompareCents(match, priceEl, sectionRoot, false);
            const compareSqftText = compareCents > priceCents
              ? this._formatMoney(Math.round(compareCents / area))
              : '';
            this._setOptionSqftText(sqftEl, this._formatMoney(perSqftCents), compareSqftText);
          });
        },
        _normalizeMoneyText(text) {
          return String(text || '').replace(/\s*\/\s*sq\.?\s*ft\.?/i, '').trim();
        },
        _setOptionBoxPrice(priceEl, saleText, compareText = '') {
          if (!priceEl) return;
          const amount = this._normalizeMoneyText(saleText);
          const compareAmount = this._normalizeMoneyText(compareText);
          const boxEl = priceEl.closest('.variant-option-horizontal__box');
          let compareEl = boxEl?.querySelector(':scope > .variant-option-horizontal__compare, :scope > s.data-wpd-hide, :scope > s');

          priceEl.textContent = amount;
          priceEl.classList.toggle('price-sale', Boolean(compareAmount && compareAmount !== amount));

          if (compareAmount && compareAmount !== amount) {
            if (!compareEl && boxEl) {
              compareEl = document.createElement('s');
              compareEl.className = 'variant-option-horizontal__compare data-wpd-hide';
              boxEl.insertBefore(compareEl, priceEl);
            }
            if (compareEl) {
              compareEl.textContent = compareAmount;
              compareEl.hidden = false;
            }
          } else if (compareEl) {
            compareEl.remove();
          }
        },
        _setOptionSqftText(sqftEl, text, compareText = '') {
          const amount = this._normalizeMoneyText(text);
          const compareAmount = this._normalizeMoneyText(compareText);
          const valueEl = sqftEl.querySelector('.variant-option-horizontal__sqft-value');
          if (valueEl) {
            if (compareAmount && compareAmount !== amount) {
              valueEl.innerHTML = `<s class="variant-option-horizontal__compare data-wpd-hide">${compareAmount}</s><span class="variant-option-horizontal__sqft-sale price-sale">${amount}</span>`;
            } else {
              valueEl.innerHTML = amount
                ? `<span class="variant-option-horizontal__sqft-sale">${amount}</span>`
                : '';
            }
            return;
          }
          sqftEl.textContent = amount ? `${amount} / sq. ft.` : '';
        },
        _getMainPriceElement(sectionRoot) {
          return sectionRoot.querySelector('.main-product-price [data-wpd-product-handle]')
            || sectionRoot.querySelector('#price-' + sectionId + ' [data-wpd-product-handle]');
        },
        _getMainPriceText(sectionRoot) {
          const mainPriceEl = this._getMainPriceElement(sectionRoot);
          if (!mainPriceEl) return '';
          const clone = mainPriceEl.cloneNode(true);
          clone.querySelectorAll('s, .wpd-ext-compare-at-price, .main-product-price__per-unit').forEach((node) => node.remove());
          return (clone.textContent || '').trim();
        },
        _getMainCompareText(sectionRoot) {
          const mainPriceEl = this._getMainPriceElement(sectionRoot);
          if (!mainPriceEl) return '';
          const container = mainPriceEl.closest('.price, .price-sale, [data-wpd-product-handle]')?.parentElement
            || mainPriceEl.parentElement;
          const strike = container?.querySelector('s .data-wpd-hide, s.wpd-ext-compare-at-price, s')
            || mainPriceEl.querySelector('s, .wpd-ext-compare-at-price');
          return this._normalizeMoneyText(strike?.textContent || '');
        },
        _getMainSqftText(sectionRoot) {
          const sqftEl = sectionRoot.querySelector('.main-product-price__sqft-value');
          if (!sqftEl) return '';
          const clone = sqftEl.cloneNode(true);
          clone.querySelectorAll('s, .wpd-ext-compare-at-price').forEach((node) => node.remove());
          return (clone.textContent || '').trim();
        },
        _getMainSqftCompareText(sectionRoot) {
          const sqftEl = sectionRoot.querySelector('.main-product-price__sqft-value');
          const strike = sqftEl?.querySelector('s, .wpd-ext-compare-at-price');
          return this._normalizeMoneyText(strike?.textContent || '');
        },
        _parseDisplayedPriceCents(element) {
          if (!element) return 0;
          const clone = element.cloneNode(true);
          clone.querySelectorAll('s, .wpd-ext-compare-at-price, .main-product-price__per-unit, .main-product-price__sqft').forEach((node) => node.remove());
          const dollars = parseFloat((clone.textContent || '').replace(/[^0-9.]/g, ''));
          if (!dollars || Number.isNaN(dollars)) return 0;
          return Math.round(dollars * 100);
        },
        _getOptionDisplayPriceCents(variant, priceEl, sectionRoot, useMainPrice) {
          if (useMainPrice) {
            const mainCents = this._parseDisplayedPriceCents(this._getMainPriceElement(sectionRoot));
            if (mainCents > 0) return mainCents;
          }

          if (priceEl?.classList?.contains('wpd-processed')) {
            const wpdCents = this._parseDisplayedPriceCents(priceEl);
            if (wpdCents > 0) return wpdCents;
          }

          if (typeof window.wpdGetTradeBoxPriceForVariant === 'function') {
            const trade = window.wpdGetTradeBoxPriceForVariant(variant.id, sectionRoot);
            if (trade?.price > 0) return trade.price;
          }

          return parseFloat(variant.price) || 0;
        },
        _getOptionDisplayCompareCents(variant, priceEl, sectionRoot, useMainPrice) {
          if (useMainPrice) {
            const mainCompareText = this._getMainCompareText(sectionRoot);
            const dollars = parseFloat(String(mainCompareText).replace(/[^0-9.]/g, ''));
            if (dollars > 0) return Math.round(dollars * 100);
          }

          if (priceEl?.classList?.contains('wpd-processed')) {
            const boxEl = priceEl.closest('.variant-option-horizontal__box');
            const strike = boxEl?.querySelector('s') || priceEl.querySelector('s, .wpd-ext-compare-at-price');
            const strikeCents = this._parseDisplayedPriceCents(strike);
            if (strikeCents > 0) return strikeCents;
            const attrCompare = parseInt(priceEl.getAttribute('data-wpd-variant-compare-at-price'), 10) || 0;
            const saleCents = this._parseDisplayedPriceCents(priceEl);
            if (attrCompare > saleCents) return attrCompare;
          }

          if (typeof window.wpdGetTradeBoxPriceForVariant === 'function') {
            const trade = window.wpdGetTradeBoxPriceForVariant(variant.id, sectionRoot);
            if (trade?.compareAtPrice > trade?.price) return trade.compareAtPrice;
          }

          const compare = parseFloat(variant.compare_at_price) || 0;
          const price = parseFloat(variant.price) || 0;
          return compare > price ? compare : 0;
        },

        _isBoxVariant(variant) {
          if (!variant || !variant.title) return false;
          
          const title = variant.title.toLowerCase();
          const sku = variant.sku || '';
          
          // Check if title contains box-related keywords
          if (title.includes('box of') || title.includes('pack of') || title.includes('set of')) {
            return true;
          }
          
          // Check if SKU contains 'B' AND title contains 'box of'
          if (sku.includes('B') && title.includes('box of')) {
            return true;
          }
          
          return false;
        },
        _isSampleVariant(variant) {
          if (!variant) return false;
          const title = String(variant.title || '').toLowerCase();
          const options = Array.isArray(variant.options)
            ? variant.options.join(' ').toLowerCase()
            : '';
          const haystack = `${title} ${options}`;
          return (
            haystack.includes('sample') ||
            haystack.includes('single tile') ||
            haystack.includes('single sheet') ||
            haystack.includes('single product')
          );
        },
        _getSelectedOptionsByPosition() {
          const selectedByPos = {};
          this.$el.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
            const pos = parseInt(input.getAttribute('option-pos'), 10);
            if (pos) selectedByPos[pos] = input.value;
          });
          return selectedByPos;
        },
        _findVariantForOptionValue(optionPos, optionValue, selectedByPos = null) {
          if (!this.variants?.length || !optionPos || optionValue == null) return null;
          const selected = selectedByPos || this._getSelectedOptionsByPosition();

          return this.variants.find((variant) => {
            for (let p = 1; p <= 3; p += 1) {
              const variantOpt = variant[`option${p}`];
              if (!variantOpt) continue;
              const expected = p === optionPos ? optionValue : selected[p];
              if (!expected) continue;
              if (this._normalizeOption(variantOpt) !== this._normalizeOption(expected)) return false;
            }
            return true;
          }) || null;
        },
        _syncCurrentVariantFromHorizontalPicker() {
          const formId = `product-form-${sectionId}`;
          const horizontalChecked =
            this.$el.querySelector(`.variant-option-horizontal input[type="radio"][form="${formId}"]:checked`) ||
            this.$el.querySelector('.variant-option-horizontal input[type="radio"]:checked');
          if (!horizontalChecked || !this.variants?.length) return false;

          const label = horizontalChecked.id
            ? this.$el.querySelector(`label.variant-option-label--horizontal[for="${horizontalChecked.id}"]`)
            : null;
          const optionPos = parseInt(horizontalChecked.getAttribute('option-pos'), 10);
          const matched = this._findVariantForOptionValue(optionPos, horizontalChecked.value);
          if (!matched) return false;

          if (label) label.dataset.variantId = String(matched.id);

          this.currentVariant = matched;
          return true;
        },
        _extractColorName(variantTitle) {
          if (!variantTitle) return variantTitle;
          
          // Extract color name by taking everything before the first "/"
          const parts = variantTitle.split(' / ');
          return parts[0].trim();
        },
        _updateVariantInput() {
          const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}, #product-form-sticky-${sectionId}`);
          productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (!input) return;
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          })
        },
        _updateProductForms() {
          const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}, #product-form-sticky-${sectionId}`);
          productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            if (input) {
              input.value = this.currentVariant.id;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
            
            // Update data-limit attribute based on current variant
            this._updateSampleLimitAttribute(productForm);
          });
        },
        _renderPriceProduct(html) {
          const destination = document.getElementById('price-' + sectionId);
          let source = html.getElementById('price-' + sectionId);
          if(!source) {
            source = html.querySelector('.price-clone');
          }
          if (source && destination) destination.innerHTML = source.innerHTML;

          if (typeof window.wpdScheduleSqftPriceUpdate === 'function') {
            window.wpdScheduleSqftPriceUpdate(destination);
          }

          const stickyDestinations = document.querySelectorAll('.price-sticky-' + sectionId);
          if (stickyDestinations.length) {
            let stickySource = html.getElementById('price-sticky-' + sectionId);
            if (!stickySource) {
              html.querySelectorAll?.('template')?.forEach((tpl) => {
                if (!stickySource) stickySource = tpl.content.getElementById('price-sticky-' + sectionId);
              });
            }
            if (!stickySource && destination) stickySource = destination;
            if (stickySource) {
              stickyDestinations.forEach((el) => {
                el.innerHTML = stickySource.innerHTML;
              });
            }
          }
        },
        _renderProductAvailability(html) {
          const destination = document.getElementById('x-availability-notice-' + sectionId);
          const source = html.getElementById('x-availability-notice-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _renderSkuProduct(html) {
          const destination = document.getElementById('sku-' + sectionId);
          const source = html.getElementById('sku-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _renderProductBadges(html) {
          const source = html.getElementById('x-badges-'+ sectionId);
          if (!source) return;

          const destinations = [
            document.getElementById('x-badges-' + sectionId),
            document.getElementById('x-badges-mobile-' + sectionId)
          ];

          destinations.forEach((destination) => {
            if (destination) destination.innerHTML = source.innerHTML;
          });
        },
        _renderBuyButtons(html) {
          const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}, #product-form-sticky-${sectionId}`);
          
          productForms.forEach((productForm) => {
            const atcSource = html.querySelector(`#${productForm.getAttribute("id")} .add_to_cart_button`);
            const atcDestination = productForm.querySelector('.add_to_cart_button');
            if (!atcDestination) return;

            if (atcSource && atcDestination) atcDestination.innerHTML = atcSource.innerHTML;
    
            if (this.currentVariant?.available) {
              /// Enable add to cart button
              atcDestination.dataset.available = "true";
              if (html.getElementById('form-gift-card-' + sectionId)) {
                if (document.getElementById('Recipient-checkbox-' + sectionId).checked && document.getElementById('recipient-form-' + sectionId).dataset.disabled == "true") {
                  atcDestination.setAttribute('disabled', 'disabled') 
                } else {
                  atcDestination.removeAttribute('disabled');
                }
              } else {
                atcDestination.removeAttribute('disabled');
              }
            } else {
              atcDestination.dataset.available = "false";
              atcDestination.setAttribute('disabled', 'disabled');
            }
          });
          const paymentButtonDestination = document.getElementById('x-payment-button-' + sectionId);
          const paymentButtonSource = html.getElementById('x-payment-button-' + sectionId);
          if (paymentButtonSource && paymentButtonDestination) {
            if (paymentButtonSource.classList.contains('hidden')) {
              paymentButtonDestination.classList.add('hidden');
            } else {
              paymentButtonDestination.classList.remove('hidden');
            }
          }
        },
        _setMessagePreOrder(html) {
          const msg = document.querySelector(`.pre-order-${sectionId}`);
          if (!msg) return;
          msg.classList.add('hidden');
          const msg_pre = html.getElementById(`pre-order-${sectionId}`);
          if (msg_pre) {
            msg.classList.remove('hidden');
            msg.innerHTML = msg_pre.innerHTML;
          }
        },
        _setEstimateDelivery(html) {
          const est = document.getElementById(`x-estimate-delivery-${sectionId}`);
          if (!est) return;
          const est_res = html.getElementById(`x-estimate-delivery-${sectionId}`);
          if (est_res.classList.contains('disable-estimate')) {
            est.classList.add('hidden');
          } else {
            est.classList.remove('hidden');
            est.innerHTML = est_res.innerHTML;
          }

          const estimateDeliveryCart = document.querySelectorAll(`.cart-edt-${sectionId}`);
          const estimateDeliveryCartUpdate = html.querySelectorAll(`.cart-edt-${sectionId}`);
          if (estimateDeliveryCart.length > 0 && estimateDeliveryCartUpdate.length > 0) {
            estimateDeliveryCart.forEach((item, index) => {
              if(estimateDeliveryCartUpdate[index] != undefined && estimateDeliveryCartUpdate[index].innerHTML != undefined ){
                item.innerHTML = estimateDeliveryCartUpdate[index].innerHTML;
              }
            })
          }
        },
        _setMetafieldInfo(html, query) {
          const content_arr = document.querySelectorAll(`${query}-${sectionId}`);
          const content_res_arr = html.querySelectorAll(`${query}-${sectionId}`);
          if (content_arr.length > 0 && content_res_arr.length > 0) {
            content_arr.forEach((toc, index) => {
              toc.innerHTML = content_res_arr[index].innerHTML;
            })
          }
        },
        _updateSameColorDifferentSize(html) {
          if (!html) return;
          const destinations = document.querySelectorAll(`.same-color-different-size-${sectionId}`);
          const sources = html.querySelectorAll(`.same-color-different-size-${sectionId}`);
          if (!destinations.length || !sources.length) return;

          destinations.forEach((destination, index) => {
            const source = sources[index];
            if (!source) return;
            destination.innerHTML = source.innerHTML;
            if (window.Alpine && typeof Alpine.initTree === 'function') {
              Alpine.initTree(destination);
            }
          });
        },
        _setPreorderProperties(html) {
          const preorder = document.getElementById(`preorder-${sectionId}`);
          const preorder_res = html.getElementById(`preorder-${sectionId}`);
          if (preorder && preorder_res) preorder.innerHTML = preorder_res.innerHTML;
        },
        _setCartEstimateDelivery(html) {
          const est = document.getElementById(`cart-edt-${sectionId}`);
          const est_res = html.getElementById(`cart-edt-${sectionId}`);
          if (est && est_res) est.innerHTML = est_res.innerHTML;
        },
        _setBackInStockAlert(html) {
          if (!this.initialized) {
            this.initialized = true;
            return;
          }
          const destination = document.getElementById(`back_in_stock_alert-${sectionId}`);
          const source = html.getElementById(`back_in_stock_alert-${sectionId}`);
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _setPickupPreOrder(html) {
          const pickup = document.getElementById(`pickup-pre-order-${sectionId}`);
          if (!pickup) return;
          const pickup_res = html.getElementById(`pickup-pre-order-${sectionId}`);
          if (pickup_res.classList.contains('disable-pickup')) {
            pickup.classList.add('hidden');
          } else {
            pickup.classList.remove('hidden');
          }
        },
        _setUnavailable() {
          const price = document.getElementById(`price-` + sectionId);
          if (price) price.style.visibility = 'hidden';

          const priceDesktop = document.getElementById(`price-sticky-${sectionId}`);
          if (priceDesktop) priceDesktop.classList.add('hidden');
          
          const inventory = document.getElementById(`block-inventory-` + sectionId);
          if (inventory) inventory.classList.add('hidden');
  
          const badges = document.getElementById(`x-badges-` + sectionId);
          if (badges) badges.setAttribute('hidden', '');
          const badgesMobile = document.getElementById(`x-badges-mobile-` + sectionId);
          if (badgesMobile) badgesMobile.setAttribute('hidden', '');
  
          const pickup = document.getElementById(`pickup-` + sectionId);
          if (pickup) pickup.classList.add('hidden');
  
          const quantity = document.getElementById('x-quantity-' + sectionId);
          if (quantity) quantity.classList.add('unavailable');

          const msg_pre = document.querySelector(`.pre-order-${sectionId}`);
          if (msg_pre) msg_pre.classList.add('hidden');
          
          const sku = document.getElementById('sku-' + sectionId);
          if (sku) sku.classList.add('hidden');
          const back_in_stock_alert = document.getElementById(`back_in_stock_alert-${sectionId}`);
          if (back_in_stock_alert) back_in_stock_alert.classList.add('hidden');

          this._setBuyButtonUnavailable();
        },
        _setAvailable() {
          const price = document.getElementById(`price-` + sectionId);
          if (price) price.style.visibility = '';
  
          const inventory = document.getElementById(`block-inventory-` + sectionId);
          if (inventory) inventory.classList.remove('hidden');
  
          const badges = document.getElementById(`x-badges-` + sectionId);
          if (badges) badges.removeAttribute('hidden');
          const badgesMobile = document.getElementById(`x-badges-mobile-` + sectionId);
          if (badgesMobile) badgesMobile.removeAttribute('hidden');
  
          const pickup = document.getElementById(`pickup-` + sectionId);
          if (pickup) pickup.classList.remove('hidden');
  
          const quantity = document.getElementById('x-quantity-' + sectionId);
          if (quantity) quantity.classList.remove('unavailable');

          const sku = document.getElementById('sku-' + sectionId);
          if (sku) sku.classList.remove('hidden');

          const back_in_stock_alert = document.getElementById(`back_in_stock_alert-${sectionId}`);
          if (back_in_stock_alert) back_in_stock_alert.classList.remove('hidden');
        },
        _setBuyButtonUnavailable() {
          const productForms = document.querySelectorAll(`#product-form-${sectionId},  #product-form-sticky-${sectionId}`);
          productForms.forEach((productForm) => {
            const addButton = productForm.querySelector('.add_to_cart_button');
            if (!addButton) return;
            addButton.setAttribute('disabled', 'disabled');
            const addButtonText = addButton.querySelector('.x-atc-text');
            if (addButtonText) addButtonText.textContent = unavailableText;
          });
        },
        _dispatchUpdateVariant(html="") {
          document.dispatchEvent(new CustomEvent(`eurus:product-card-variant-select:updated:${sectionId}`, {
            detail: {
              currentVariant: this.currentVariant,
              currentAvailableOptions: this.currentAvailableOptions,
              options: this.options,
              html: html
            }
          }));
        },
        _updateImageVariant(productFeaturedImage = "") {
          if (this.currentVariant != null) {
            let featured_image = productFeaturedImage;
            if (this.currentVariant.featured_image != null) {
              featured_image = this.currentVariant.featured_image.src;
            }
            Alpine.store('xPreviewColorSwatch').updateImage(this.$el, productUrl, featured_image, this.currentVariant.id, sectionId);
          }
        },
        _updateOptionImage() {
          if (element.closest('.card-product') && this.currentVariant && this.currentVariant.featured_image) {
            const option_image = this._getSwatchImageUrl(this.currentVariant.featured_image.src);
            const card_label = this.options
              .map(option => element.querySelector(`label.color-watches[data-name*="${option.replace(/["\\]/g, '\\$&')}"]`))
              .find(label => label !== null);
            if (card_label) card_label.style.setProperty('--bg-image', `url(${option_image})`)
          }
        },
        initEventSticky() {
          document.addEventListener(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, (e) => {
            this.handleSticky = e.detail.variantElSticky;
            this.updateVariantSelector(e.detail.inputId, e.detail.targetUrl);
          });
        },
        changeSelectOption(event) {
          Array.from(event.target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
            event.target.selectedOptions[0].setAttribute('selected', 'selected');
          const input = event.target.selectedOptions[0];
          const inputId = input.id;
          const targetUrl = input.dataset.productUrl;
          this.updateVariantSelector(inputId, targetUrl);
        },
        updateVariantSelector(inputId, target) {
          if (chooseOption) {
            this.handleSectionId = 'choose-option';
          }
          if (productBundle) {
            this.handleSectionId = handleSectionId;
          }
          this.currentVariant = this._getVariantData(inputId);
          let updateFullpage = false;
          let callback = () => {};
          
          const targetUrl = target || element.dataset.url;
          if (element.dataset.url !== targetUrl) {
            this._updateURL(targetUrl);
            this._setAvailable();
            if (isProductPage) {
              updateFullpage = true;
            }
            callback = (html) => {
              this._handleSwapProduct(sectionId, html, updateFullpage);
              this._handleSwapQuickAdd(html);
              this._renderCardBundle(html);
              this._renderCardFBT(html);
              this._dispatchUpdateVariant(html);
            };
          } else if (!this.currentVariant) {
            this._setUnavailable();
            callback = (html) => {
              this._updateOptionValues(html);
              this._dispatchVariantSelected(html);
              this._dispatchUpdateVariant(html);
            };
          } else {
            this._updateURL(targetUrl);
            this._updateVariantInput();
            this._setAvailable();
            callback = (html) => {
              this._handleUpdateProductInfo(html);
              this._handleAvailable(html);
            }
          }
          this._renderProductInfo(targetUrl, callback, updateFullpage);
          
          // Handle calculator visibility immediately after variant change
          this._handleCalculatorVisibility();
          
          // Reset quantity selector to minimum value on variant change
          this._resetQuantitySelector();
        },
        _renderProductInfo(url, callback, updateFullpage) {
          let link = "";
          let params = `option_values=${this._getSelectedOptionValues().join(',')}`;
          if (chooseOption || productBundle) {
            params = `option_values=${this._getSelectedOptionValues().join(',')}&page=${pageParam}`;
          }
          link = updateFullpage?`${url}?${params}`:`${url}?section_id=${this.handleSectionId}&${params}`;
      
          if (this.cachedResults[link]) {
            const html = this.cachedResults[link];
            callback(html);
          } else {
            fetch(link)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                callback(html);
                this.cachedResults[link] = html;
              })
          }
          this.handleSticky = '';
        },
        _handleUpdateProductInfo(html) {
            const updateToken = ++this._variantUpdateToken;
            this._renderCardBundle(html);
            this._renderCardFBT(html);
            this._applyCriticalVariantHtml(html);
            this._updateOptionValues(html);
            this._dispatchUpdateVariant(html);

            // Same INP split as radio picker: heavy DOM + listeners after paint.
            this._scheduleAfterNextPaint(() => {
              if (updateToken !== this._variantUpdateToken) return;
              this._applyDeferredVariantHtml(html, { updateMedia: true, quantitySectionId: this.handleSectionId });
              Alpine.store('xPickupAvailable').updatePickUp(sectionId, this.currentVariant?.id);
              this._dispatchVariantSelected(html);
              this._handleCalculatorVisibility();
              this._resetQuantitySelector();
            });
        },
        initFirstAvailableVariant(el) {
          this.currentVariant = JSON.parse(el.querySelector(`script[type="application/json"][data-selected-variant]`).textContent);
          if (!productBundle) {
            document.addEventListener('eurus:cart:items-changed', () => {
              this.cachedResults = [];
              Alpine.store('xUpdateVariantQuanity').updateQuantity(sectionId, productUrl, this.currentVariant?.id);
            });
          }
          
          // Handle calculator visibility on initial load
          this.$nextTick(() => {
            // Initialize variant statuses for proper disabled state on load
            this._updateVariantStatuses();
            this._handleCalculatorVisibility();
          });
        },
        _handleAvailable(html) {
          const selectedVariant = html.querySelector('.variant-selects [data-selected-variant]')?.innerHTML;
          if (selectedVariant == 'null') {
            this._setUnavailable();
          }
        },
        _handleCalculatorVisibility() {
          if (!this.currentVariant) return;

          const variantOption = this.currentVariant.option3 || this.currentVariant.option2 || this.currentVariant.option1;
          const normalizedVariantOption = (variantOption || '').toLowerCase();

          const sectionRoot =
            document.getElementById(`shopify-section-${sectionId}`) ||
            this.$el.closest(`#shopify-section-${sectionId}`) ||
            this.$el;

          const calculatorWrappers = sectionRoot.querySelectorAll('.calculator-wrapper');
          const calculatorBlocks = sectionRoot.querySelectorAll('.calculator-block');
          const priceBlocks = sectionRoot.querySelectorAll('#price-' + sectionId);
          const sampleButtons = sectionRoot.querySelectorAll('[data-sample-button]');
          const quantityInputs = sectionRoot.querySelectorAll('#Quantity-' + sectionId);
          const finalQuantityInputs = sectionRoot.querySelectorAll('[id*=finalquantity]');

          // Check if product has template-name="without-calculator" from product container or calculator wrapper
          const productContainer = sectionRoot.closest('[data-template-name]') || sectionRoot.querySelector(`#x-product-template-${productId}-${sectionId}`);
          const templateName = productContainer?.getAttribute('data-template-name') || 
            (calculatorWrappers.length > 0 ? calculatorWrappers[0]?.getAttribute('data-template-name') : null);
          const hasWithoutCalculatorTemplate = templateName === 'without-calculator';
          const isBullnoseCalculatorTemplate =
            templateName === 'zellige-bullnose' || templateName === 'cement-bullnose';

          const isSampleLikeOption = normalizedVariantOption &&
            (normalizedVariantOption.includes('sample') ||
              normalizedVariantOption.includes('trade sample'));

          let isCalculatorVariant = false;
          if (isBullnoseCalculatorTemplate) {
            // Bullnose is sold by the piece - show calculator for non-sample options
            isCalculatorVariant = Boolean(normalizedVariantOption) && !isSampleLikeOption;
          } else {
            isCalculatorVariant = normalizedVariantOption &&
              !normalizedVariantOption.includes('sample') &&
              !normalizedVariantOption.includes('single') &&
              !normalizedVariantOption.includes('per tile') &&
              !normalizedVariantOption.includes('per piece') &&
              !normalizedVariantOption.includes('full sheet') &&
              !hasWithoutCalculatorTemplate;
          }

          if (isCalculatorVariant) {
            // Show calculator and hide price
            calculatorWrappers.forEach(wrapper => {
              wrapper.classList.add('active');
              wrapper.style.display = 'block';
              wrapper.style.visibility = 'visible';
              wrapper.style.opacity = '1';
            });
            calculatorBlocks.forEach(block => {
              block.style.display = 'block';
              block.style.visibility = 'visible';
              block.style.opacity = '1';
            });
            // priceBlocks.forEach(block => {
            //   block.style.display = 'none';
            //   block.style.visibility = 'hidden';
            //   block.style.opacity = '0';
            // });
            
            // Disable sample buttons
            sampleButtons.forEach(btn => btn.setAttribute('disabled', ''));
            
            // Sync quantity and update price per tile
            const finalQuantity = finalQuantityInputs[0]?.value || 1;
            quantityInputs.forEach(input => input.value = finalQuantity);

            if (isBullnoseCalculatorTemplate) {
              // Bullnose uses assets/bullnose-calculator.js which owns its own `.total-value`
              // (computed from linear feet × pieces-per-ft × piece price). Skip the box-oriented
              // helpers so they don't clobber the bullnose total or price-per-tile display.
            } else {
              // Update price per tile
              this._updatePricePerTile();

              // Update total price
              this._updateTotalPrice(finalQuantity);

              // Update calculator prices
              this._scheduleCalculatorPriceUpdate();
            }

          } else {
            // Hide calculator and show price
            calculatorWrappers.forEach(wrapper => {
              wrapper.classList.remove('active');
              wrapper.style.display = 'none';
              wrapper.style.visibility = 'hidden';
              wrapper.style.opacity = '0';
            });
            calculatorBlocks.forEach(block => {
              block.style.display = 'none';
              block.style.visibility = 'hidden';
              block.style.opacity = '0';
            });
            // priceBlocks.forEach(block => {
            //   block.style.display = 'flex';
            //   block.style.visibility = 'visible';
            //   block.style.opacity = '1';
            // });
            
            // Enable sample buttons
            sampleButtons.forEach(btn => btn.removeAttribute('disabled'));
            
            // Reset quantity to 1
            quantityInputs.forEach(input => input.value = 1);
          }
        },
        _updatePricePerTile() {
          if (!this.currentVariant) return;
          
          const variantOption = this.currentVariant.option2 || this.currentVariant.option3;
          if (!variantOption || !variantOption.includes('Box of ')) return;
          
          const boxMatch = variantOption.match(/Box of (\d+)/);
          if (!boxMatch) return;
          
          const boxQuantity = parseFloat(boxMatch[1]);
          const pricePerTile = parseFloat(this.currentVariant.price) / boxQuantity;
          const formattedPrice = this._formatMoney(pricePerTile);

          const sectionRoot = document.getElementById(`shopify-section-${sectionId}`) || this.$el;
          sectionRoot.querySelectorAll('.per_tile_price').forEach(el => {
            el.textContent = formattedPrice;
          });
          sectionRoot.querySelectorAll('.calculator-wrapper').forEach((w) => {
            w.dataset.tilesPerBox = String(parseInt(boxMatch[1], 10));
          });
        },
        _updateTotalPrice(quantity) {
          if (!this.currentVariant) return;

          const sectionRoot = document.getElementById(`shopify-section-${sectionId}`) || this.$el;
          const { price } = this._getEffectiveCalculatorPrices(sectionRoot);
          const totalPrice = parseFloat(price) * parseFloat(quantity);
          const formattedPrice = this._formatMoney(totalPrice);
          sectionRoot.querySelectorAll('#total_price_2').forEach(el => {
            el.textContent = formattedPrice;
          });
        },
        _formatMoney(amount) {
          if (window.theme?.Currency?.formatMoney && window.theme?.settings?.moneyFormat) {
            return window.theme.Currency.formatMoney(amount, window.theme.settings.moneyFormat);
          }
          // fallback
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: window.Shopify?.currency?.active || 'USD'
          }).format(amount / 100); // Shopify price is in cents
        },
        _parsePriceToCents(value) {
          if (value === null || value === undefined) return null;
          if (typeof value === 'number' && Number.isFinite(value)) {
            return Math.round(value);
          }

          const normalized = String(value).replace(/[^0-9.,-]/g, '');
          if (!normalized) return null;
          const standardized = normalized.includes('.') ? normalized.replace(/,/g, '') : normalized.replace(',', '.');
          const amount = parseFloat(standardized);
          if (!Number.isFinite(amount)) return null;
          return Math.round(amount * 100);
        },
        _isTradeCustomer() {
          return Boolean(window.shopifyCustomer || window.wcp_customer?.tags?.length);
        },
        _scheduleCalculatorPriceUpdate() {
          this._cancelCalculatorPriceTimers();
          this._calculatorPriceTimers = [];
          const run = () => {
            this._updateCalculatorPrices();
            this._updateHorizontalOptionPrices();
          };

          // One immediate pass + one short retry for WPD/trade markup.
          // Extra 600/1200 passes caused visible price flicker in the calculator.
          run();
          this._calculatorPriceTimers.push(setTimeout(run, 350));
        },
        _cancelCalculatorPriceTimers() {
          if (!this._calculatorPriceTimers) return;
          this._calculatorPriceTimers.forEach((timerId) => clearTimeout(timerId));
          this._calculatorPriceTimers = [];
        },
        _setCalculatorSqftText(sectionRoot, areaActual) {
          if (!sectionRoot || !(areaActual > 0)) return;

          // Keep calculator "/ sq. ft." identical to the main price block whenever possible.
          const mainSqftText = this._getMainSqftText(sectionRoot);
          if (mainSqftText) {
            sectionRoot.querySelectorAll('.js-calculator-sqft-value').forEach((el) => {
              el.textContent = mainSqftText;
            });
            return;
          }

          const sqftBasis = this._getSqftBasisVariant();
          if (!sqftBasis) return;

          let basisCents = parseFloat(sqftBasis.price) || 0;
          if (typeof window.wpdGetTradeBoxPriceForVariant === 'function') {
            const tradePrice = window.wpdGetTradeBoxPriceForVariant(sqftBasis.id, sectionRoot);
            if (tradePrice?.price) basisCents = tradePrice.price;
          }
          if (!(basisCents > 0)) return;

          // Match Liquid: round cents before formatting (price / sqft_per_unit | round).
          const sqftCents = Math.round(basisCents / areaActual);
          const formattedSqftPrice = this._formatMoney(sqftCents);
          sectionRoot.querySelectorAll('.js-calculator-sqft-value').forEach((el) => {
            el.textContent = formattedSqftPrice;
          });
        },
        _getDisplayedCalculatorPrices(sectionRoot, fallbackPrice, fallbackCompareAtPrice) {
          const priceBox = sectionRoot.querySelector('.price_per_box');
          if (!priceBox) {
            return {
              price: fallbackPrice,
              compareAtPrice: fallbackCompareAtPrice
            };
          }

          const compareFromStrike = priceBox.querySelector('s, .wpd-ext-compare-at-price');
          const compareFromParent = priceBox.closest('.calculator-value')?.querySelector('[data-compare-price-2]');
          let compareAtPrice = this._parsePriceToCents(compareFromStrike?.textContent)
            || this._parsePriceToCents(compareFromParent?.textContent)
            || fallbackCompareAtPrice;

          const clone = priceBox.cloneNode(true);
          clone.querySelectorAll('s, .wpd-ext-compare-at-price').forEach((node) => node.remove());
          let price = this._parsePriceToCents(clone.textContent);

          if (!price || price <= 0) {
            price = this._parsePriceToCents(priceBox.textContent);
          }
          if (!price || price <= 0) {
            price = fallbackPrice;
          }

          if (!compareAtPrice || compareAtPrice <= price) {
            compareAtPrice = fallbackCompareAtPrice;
          }

          return {
            price,
            compareAtPrice
          };
        },
        // PDP fix 2026-07-12: per-sqft basis = box variant for the selected color (fallback: any box, then current).
        _getSqftBasisVariant() {
          const cur = this.currentVariant;
          if (!cur) return null;
          const title = (v) => v?.public_title || v?.title || '';
          if (title(cur).includes('Box')) return cur;
          const pool = this.variants || [];
          const sameColorBox = pool.find(v => title(v).includes('Box') && v.option1 === cur.option1);
          if (sameColorBox) return sameColorBox;
          return pool.find(v => title(v).includes('Box')) || cur;
        },
        _getEffectiveCalculatorPrices(sectionRoot) {
          const fallbackPrice = parseFloat(this.currentVariant?.price) || 0;
          const fallbackCompareAtPrice = this.currentVariant?.compare_at_price ? parseFloat(this.currentVariant.compare_at_price) : null;

          if (this._isTradeCustomer() && typeof window.wpdGetTradeBoxPriceForVariant === 'function') {
            const tradePrice = window.wpdGetTradeBoxPriceForVariant(this.currentVariant?.id, sectionRoot);
            if (tradePrice) {
              return tradePrice;
            }
          }

          const displayed = this._getDisplayedCalculatorPrices(sectionRoot, fallbackPrice, fallbackCompareAtPrice);
          const priceBox = sectionRoot.querySelector('.price_per_box');

          if (!priceBox) {
            return displayed;
          }

          const hasWholesaleMarkup = priceBox.classList.contains('wpd-processed')
            || Boolean(priceBox.querySelector('.wpd-ext-compare-at-price'));
          const hasTradePriceDelta = Math.abs((displayed.price || 0) - fallbackPrice) > 1;
          const displayedVariantId = priceBox.dataset?.wpdVariantId;
          const isDisplayedForCurrentVariant = displayedVariantId
            ? String(displayedVariantId) === String(this.currentVariant?.id)
            : false;

          if ((hasWholesaleMarkup || hasTradePriceDelta) && isDisplayedForCurrentVariant) {
            return displayed;
          }

          if (this._isTradeCustomer()) {
            return {
              price: null,
              compareAtPrice: null,
              pendingTradePrice: true
            };
          }

          return {
            price: fallbackPrice,
            compareAtPrice: fallbackCompareAtPrice
          };
        },
        
        _updateCalculatorPrices() {
          if (!this.currentVariant) return;

          const sectionRoot = document.getElementById(`shopify-section-${sectionId}`) || this.$el;
          const calculatorWrapper = sectionRoot.querySelector('.calculator-wrapper');
          if (!calculatorWrapper) return;
          
          const areaActual = parseFloat(calculatorWrapper.getAttribute('data-area-actual') || 0);
          if (areaActual <= 0) return;

          const effectivePrices = this._getEffectiveCalculatorPrices(sectionRoot);
          if (effectivePrices.pendingTradePrice || effectivePrices.price === null) {
            sectionRoot.querySelectorAll('.price_per_box').forEach((priceBox) => {
              priceBox.setAttribute('data-wpd-variant-id', String(this.currentVariant.id));
            });
            return;
          }

          const { price, compareAtPrice } = effectivePrices;
          const hasComparePrice = compareAtPrice && compareAtPrice > price;
          
          this._setCalculatorSqftText(sectionRoot, areaActual);
          
          // Update Price per Box and compare price
          const formattedBoxPrice = this._formatMoney(price);
          sectionRoot.querySelectorAll('.price_per_box').forEach(priceBox => {
            const productHandle = priceBox.getAttribute('data-wpd-product-handle');
            const productId = priceBox.getAttribute('data-wpd-product-id');
            const shouldKeepProcessed = priceBox.classList.contains('wpd-processed') || this._isTradeCustomer();

            priceBox.textContent = formattedBoxPrice;
            priceBox.setAttribute('data-wpd-variant-id', String(this.currentVariant.id));
            priceBox.setAttribute('data-wpd-variant-price', Math.round(price));
            priceBox.setAttribute('data-wpd-variant-compare-at-price', Math.round(compareAtPrice || 0));
            priceBox.style.visibility = 'visible';

            if (productHandle) {
              priceBox.setAttribute('data-wpd-product-handle', productHandle);
            }
            if (productId) {
              priceBox.setAttribute('data-wpd-product-id', productId);
            }
            if (shouldKeepProcessed) {
              priceBox.classList.add('wpd-processed');
            }
            
            // Update styling based on compare price
            if (hasComparePrice) {
              priceBox.style.color = 'rgb(177, 77, 77)';
            } else {
              priceBox.style.color = '';
            }
            
            // Find the parent calculator-value div
            const parentDiv = priceBox.closest('.calculator-value');
            if (parentDiv) {
              // Find or create compare price element
              let comparePriceEl = parentDiv.querySelector('[data-compare-price-2]');
              
              if (hasComparePrice) {
                const formattedComparePrice = this._formatMoney(compareAtPrice);
                if (!comparePriceEl) {
                  // Create compare price element if it doesn't exist
                  comparePriceEl = document.createElement('strike');
                  comparePriceEl.setAttribute('data-compare-price-2', '');
                  comparePriceEl.className = 'product__price--compare pr-1';
                  comparePriceEl.style.color = 'gray';
                  parentDiv.insertBefore(comparePriceEl, priceBox);
                }
                comparePriceEl.textContent = formattedComparePrice;
                comparePriceEl.style.display = '';
              } else if (comparePriceEl) {
                // Hide compare price if it exists but shouldn't be shown
                comparePriceEl.style.display = 'none';
              }
            }
          });
          
          // Update Total Price if there's a current quantity
          const currentQuantity = sectionRoot.querySelector('#finalquantity')?.value || 1;
          if (currentQuantity > 0) {
            const totalPrice = price * currentQuantity;
            const formattedTotalPrice = this._formatMoney(totalPrice);
            sectionRoot.querySelectorAll('.total-value').forEach(el => {
              el.innerHTML = formattedTotalPrice;
            });
          }
          if (window.ProductCalculator && typeof window.ProductCalculator.updateTotalSummaryLine === 'function') {
            window.ProductCalculator.updateTotalSummaryLine();
          }
        },
        _isCurrentVariantSample() {
          if (!this.currentVariant) return false;
          const title = String(this.currentVariant.title || '').toLowerCase();
          const options = Array.isArray(this.currentVariant.options)
            ? this.currentVariant.options.join(' ').toLowerCase()
            : '';
          const haystack = `${title} ${options}`;
          return (
            haystack.includes('sample') ||
            haystack.includes('single tile') ||
            haystack.includes('single sheet')
          );
        },
        _isCurrentVariantFullSheet() {
          if (!this.currentVariant) return false;
          const title = String(this.currentVariant.title || '').toLowerCase();
          const options = Array.isArray(this.currentVariant.options)
            ? this.currentVariant.options.join(' ').toLowerCase()
            : '';
          return `${title} ${options}`.includes('full sheet');
        },
        _resetQuantitySelector() {
          if (!this.currentVariant) return;
          
          // Get the minimum quantity for the current variant + product metafield
          // Metafield MOQ applies to main (box) variants only — not samples or full sheet.
          const ruleMin = this.currentVariant.quantity_rule?.min || 1;
          const isSample = this._isCurrentVariantSample();
          const skipMoq = isSample || this._isCurrentVariantFullSheet();
          const metafieldMin = skipMoq ? 1 : this._getProductMinQuantity();
          const minQuantity = Math.max(ruleMin, metafieldMin);
          
          // Clear any existing sample limit warning messages
          this._clearSampleLimitWarnings();
          
          // Update sample limit attributes for all product forms
          const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}, #product-form-sticky-${sectionId}`);
          productForms.forEach((productForm) => {
            this._updateSampleLimitAttribute(productForm);
          });
          
          // Qty inputs are often outside the form (form="…"); sync data-limit on section inputs too.
          const sectionRoot =
            document.getElementById(`shopify-section-${sectionId}`) ||
            this.$el?.closest?.('#choose-options-content, .choose-options-content, .card-product') ||
            this.$el;
          const sampleLimitValue = (() => {
            if (!isSample) return null;
            const formWithLimit = Array.from(productForms).find((f) => f.dataset?.sampleLimit || f.getAttribute('data-sample-limit'));
            const raw =
              formWithLimit?.dataset?.sampleLimit ||
              formWithLimit?.getAttribute('data-sample-limit') ||
              window.productMetafields?.sample_limit;
            const parsed = parseInt(raw, 10);
            return Number.isFinite(parsed) ? parsed : null;
          })();
          sectionRoot.querySelectorAll('input[name="quantity"]').forEach((input) => {
            if (isSample && sampleLimitValue != null) {
              input.setAttribute('data-limit', String(sampleLimitValue));
            } else {
              input.removeAttribute('data-limit');
            }
          });
          
          // Find all quantity selector containers within this section
          const quantityContainers = document.querySelectorAll(`#shopify-section-${sectionId} .quantity-selector-container`);
          
          quantityContainers.forEach(container => {
            // Get the Alpine.js data for this container
            if (window.Alpine && container._x_dataStack && container._x_dataStack[0]) {
              const alpineData = container._x_dataStack[0];
              if (typeof alpineData.min !== 'undefined') {
                alpineData.min = minQuantity;
              }
              if (typeof alpineData.qty !== 'undefined') {
                // Reset the Alpine.js qty value to minimum
                alpineData.qty = minQuantity;
              }
              if (isSample && sampleLimitValue != null) {
                alpineData.hasSampleLimit = true;
                alpineData.sampleLimit = sampleLimitValue;
              } else {
                alpineData.hasSampleLimit = false;
                alpineData.sampleLimit = null;
              }
              
              // Keep Alpine sample-limit helpers in sync
              this._updateAlpineSampleLimitData(container);
            }
            
            // Also reset the input field directly
            const qtyInput = container.querySelector('input[name="quantity"]');
            if (qtyInput) {
              qtyInput.min = String(minQuantity);
              qtyInput.value = minQuantity;
              // Trigger input event to ensure Alpine.js updates
              qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
            }
          });
          
          // Also reset any standalone quantity inputs in this section (incl. choose-options hidden qty)
          sectionRoot.querySelectorAll('input[name="quantity"]').forEach((input) => {
            if (!input.closest('.quantity-selector-container')) {
              input.min = String(minQuantity);
              input.value = minQuantity;
              input.dispatchEvent(new Event('input', { bubbles: true }));
            }
          });
          
          // Reset calculator finalquantity inputs
          sectionRoot.querySelectorAll('#finalquantity').forEach(el => {
            el.value = minQuantity;
          });

          // Update minimum label in quantity-rules
          const rulesEl = sectionRoot.querySelector(`#quantity-rules-${sectionId}`);
          if (rulesEl) {
            if (minQuantity > 1) {
              const minLabelTemplate =
                (window.Eurus && window.Eurus.volume_pricing_minimum) || '{{ quantity }} boxes minimum';
              const minLabel = minLabelTemplate.replace(/\{\{\s*quantity\s*\}\}|\[quantity\]/g, String(minQuantity));
              let labelSpan = rulesEl.querySelector('[data-min-qty-label]');
              if (!labelSpan) {
                labelSpan = document.createElement('span');
                labelSpan.setAttribute('data-min-qty-label', '');
                rulesEl.prepend(labelSpan);
              }
              const hasFollowingRule = Array.from(rulesEl.children).some(
                (child) => child !== labelSpan && child.textContent.trim() !== ''
              );
              labelSpan.textContent = hasFollowingRule
                ? `${minLabel} /`
                : minLabel;
            } else {
              const labelSpan = rulesEl.querySelector('[data-min-qty-label]');
              if (labelSpan) labelSpan.remove();
            }
          }
          
          // Update total price with new quantity
          this._updateTotalPrice(minQuantity);

          // Re-enable/disable +/- after sample↔box (stale qty-btn--disabled blocks clicks).
          requestAnimationFrame(() => {
            if (typeof window.Eurus?.refreshQuantitySelectorUi === 'function') {
              window.Eurus.refreshQuantitySelectorUi();
            } else if (typeof window.Eurus?.enhanceQuantitySelectors === 'function') {
              window.Eurus.enhanceQuantitySelectors();
            }
          });
        },
        _getProductMinQuantity() {
          const sectionRoot =
            document.getElementById(`shopify-section-${sectionId}`) ||
            this.$el?.closest?.('#choose-options-content, .choose-options-content, .card-product') ||
            this.$el;
          const forms = sectionRoot.querySelectorAll(
            `#product-form-${sectionId}, #product-form-sticky-${sectionId}, form[data-type="add-to-cart-form"]`
          );
          for (const form of forms) {
            const raw = form.dataset?.minQuantity ?? form.getAttribute('data-min-quantity');
            const parsed = parseInt(raw, 10);
            if (Number.isFinite(parsed) && parsed > 0) {
              return parsed;
            }
          }
          return 1;
        },
        _clearSampleLimitWarnings() {
          // Remove any existing sample limit warning messages
          const sectionRoot = document.getElementById(`shopify-section-${sectionId}`) || this.$el;
          const existingWarnings = sectionRoot.querySelectorAll('.prompt');
          existingWarnings.forEach(warning => {
            warning.remove();
          });
        },
        _updateAlpineSampleLimitData(container) {
          // Update Alpine.js data to reflect current variant's sample limit status
          if (!this.currentVariant || !window.Alpine) return;
          
          const alpineData = container._x_dataStack && container._x_dataStack[0];
          if (!alpineData) return;
          
          const variantTitle = this.currentVariant.title.toLowerCase();
          const isSampleVariant = variantTitle.includes('single tile') || 
                                 variantTitle.includes('sample') || 
                                 variantTitle.includes('single sheet');
          
          // Add or update the sample limit status in Alpine.js data
          if (isSampleVariant) {
            // Get the sample limit value
            const qtyInput = container.querySelector('input[name="quantity"]');
            let sampleLimit = qtyInput ? qtyInput.dataset.limit : null;
            if (sampleLimit == null && window.productMetafields?.sample_limit != null) {
              sampleLimit = window.productMetafields.sample_limit;
            }
            const parsedLimit = parseInt(sampleLimit, 10);
            alpineData.hasSampleLimit = Number.isFinite(parsedLimit);
            alpineData.sampleLimit = Number.isFinite(parsedLimit) ? parsedLimit : null;
          } else {
            // Remove sample limit for non-sample variants
            alpineData.hasSampleLimit = false;
            alpineData.sampleLimit = null;
          }
        },
        _updateOptionValues(html) {
          if (!productBundle) {
            const variantSelects = html.querySelector('.variant-selects');
            if (variantSelects) element.innerHTML = variantSelects.innerHTML;
          }
        },
        _getVariantData(inputId) {
          return JSON.parse(this._getVariantDataElement(inputId).textContent);
        },
        _getVariantDataElement(inputId) {
          return element.querySelector(`script[type="application/json"][data-resource="${inputId}"]`);
        },
        _updateURL(url) {
          if (!isProductPage) return;
          window.history.replaceState({}, '', `${url}${this.currentVariant?.id ? `?variant=${this.currentVariant.id}` : ''}`);
        },
        _getSelectedOptionValues() {
          if (this.handleSticky == '') {
            return Array.from(element.querySelectorAll('select option[selected], fieldset input:checked')).map(
              (e) => e.dataset.optionValueId
            );
          } else {
            return Array.from(this.handleSticky.querySelectorAll('select option[selected]')).map(
              (e) => e.dataset.optionValueId
            );
          }
        },
        _renderCardBundle(html) {
          const destination = element.closest(".x-product-bundle-data");
          const card = html.getElementById('card-product-bundle-'+ this.handleSectionId);
          if (card) {
            const source = card.querySelector(".x-product-bundle-data");
            if (source && destination) destination.innerHTML = source.innerHTML;
          }
        },
        _renderCardFBT(html) {
          const destination = element.closest(".card-product-fbt");
          const source = html.querySelector('.card-product-fbt-clone .card-product-fbt');
          
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        _updateProductCardTitle() {
          // Update product card title when variant changes
          if (!isProductPage && this.currentVariant) {
            const cardProduct = element.closest('.card-product');
            if (cardProduct) {
              const cardTitle = cardProduct.querySelector('.x-card-title');
              if (cardTitle) {
                // Collection v3 cards keep the product title; only sync link + sqft price
                const keepProductTitle = cardProduct.classList.contains('card-product--collection-v3');
                // Find the variant title from the variants data
                const variantData = this.variants.find(v => v.id === this.currentVariant.id);
                if (variantData && variantData.title) {
                  // Check if this is NOT a "Box of..." variant - if so, show the corresponding Box variant title
                  if (!variantData.title.includes('Box of')) {
                    // For non-Box variants (Sample, Single Tile, etc.), find and link to the corresponding Box variant
                    const boxVariant = this.variants.find(v => 
                      v.title.includes('Box of') && 
                      v.option1 === variantData.option1
                    );

                    if (boxVariant) {
                      // Update link to point to the Box variant instead
                      const currentUrl = new URL(cardTitle.href);
                      const newUrl = new URL(currentUrl.origin + currentUrl.pathname);
                      newUrl.searchParams.set('variant', this.currentVariant.id);
                      cardTitle.href = newUrl.toString();

                      const sqftSpan = cardTitle.closest('.card-product, .grid-item, [data-product-id]')?.querySelector('[data-area-actual]');

                      if (sqftSpan && boxVariant.price) {
                        const area = parseFloat(sqftSpan.dataset.areaActual);

                        if (area > 0) {
                          // Calculate price per sqft in cents (prevents rounding errors)
                          const pricePerSqftCents = Math.round(boxVariant.price / area);
                          const formattedPrice = this._formatMoney(pricePerSqftCents);

                          // Update the visible text
                          sqftSpan.textContent = `${formattedPrice} /sqft`;
                        }
                      }

                      if (!keepProductTitle) {
                        // Update the title to show only the color name from the Box variant title
                        const colorName = this._extractColorName(boxVariant.title);
                        if (cardTitle._x_dataStack && cardTitle._x_dataStack[0]) {
                          const alpineData = cardTitle._x_dataStack[0];
                          if (alpineData.updateTitle && typeof alpineData.updateTitle === 'function') {
                            alpineData.updateTitle(colorName);
                          } else {
                            alpineData.productTitle = colorName;
                          }
                        }

                        if (cardTitle.textContent !== colorName) {
                          requestAnimationFrame(() => {
                            cardTitle.textContent = colorName;
                          });
                        }
                      }
                    }
                    
                    // Return early since we've handled non-Box variants
                    return;
                  }
                  
                  // For non-Single Tile variants, update both title and link
                  const currentUrl = new URL(cardTitle.href);
                  const newUrl = new URL(currentUrl.origin + currentUrl.pathname);
                  newUrl.searchParams.set('variant', variantData.id);
                  cardTitle.href = newUrl.toString();

                  if (!keepProductTitle) {
                    // Extract only the color name from the variant title
                    const colorName = this._extractColorName(variantData.title);
                    
                    // Check if this is an Alpine.js component
                    if (cardTitle._x_dataStack && cardTitle._x_dataStack[0]) {
                      // Try to call the updateTitle method if it exists
                      const alpineData = cardTitle._x_dataStack[0];
                      if (alpineData.updateTitle && typeof alpineData.updateTitle === 'function') {
                        alpineData.updateTitle(colorName);
                      } else {
                        // Fallback: try to update the data directly
                        if (alpineData.productTitle !== colorName) {
                          alpineData.productTitle = colorName;
                        }
                      }
                    }
                    
                    // Always try to update the text content directly as a fallback
                    if (cardTitle.textContent !== colorName) {
                      requestAnimationFrame(() => {
                        cardTitle.textContent = colorName;
                      });
                    }
                  }
                }
              }
            }
          }
        },
        _updateSampleLimitAttribute(productForm) {
          if (!productForm || !this.currentVariant) return;

          const formId = productForm.getAttribute('id') || '';
          const quantityInputs = [
            ...productForm.querySelectorAll('input[name="quantity"]'),
            ...(formId
              ? Array.from(document.querySelectorAll(`input[name="quantity"][form="${formId}"]`))
              : []),
          ];
          // De-dupe
          const uniqueInputs = Array.from(new Set(quantityInputs));
          if (!uniqueInputs.length) return;

          const variantTitle = this.currentVariant.title.toLowerCase();
          const isSampleVariant =
            variantTitle.includes('single tile') ||
            variantTitle.includes('sample') ||
            variantTitle.includes('single sheet');

          uniqueInputs.forEach((input) => {
            if (isSampleVariant) {
              let sampleLimit = null;
              if (productForm.dataset?.sampleLimit) {
                sampleLimit = productForm.dataset.sampleLimit;
              } else if (window.productMetafields && window.productMetafields.sample_limit) {
                sampleLimit = window.productMetafields.sample_limit;
              }

              const parsedLimit = parseInt(sampleLimit, 10);
              if (Number.isFinite(parsedLimit)) {
                input.setAttribute('data-limit', String(parsedLimit));
              } else {
                input.removeAttribute('data-limit');
              }
            } else {
              input.removeAttribute('data-limit');
            }
          });
        },
        _handleSwapProduct(sectionId, html, updateFullpage) {
          if (updateFullpage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            const destination = document.querySelector('main');
            const source = html.querySelector('main');
            if (source && destination) destination.innerHTML = source.innerHTML;
          } else {
            const destination = document.querySelector('.x-product-' + sectionId);
            const source = html.querySelector('.x-product-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          }
        },
        _handleSwapQuickAdd(html) {
          const destination = element.closest(".choose-options-content");
          const source = html.querySelector('.choose-options-content');
          if (source && destination) destination.innerHTML = source.innerHTML;
        }
      }))
    });
  });

  
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xPickupAvailable', {
        updatePickUp(id, variantId) {
          const container = document.getElementsByClassName('pick-up-'+ id)[0];
          if (!container) return;
  
          fetch(window.Shopify.routes.root + `variants/${variantId}/?section_id=pickup-availability`)
            .then(response => response.text())
            .then(text => {
              const pickupAvailabilityHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('.shopify-section');  
              container.innerHTML = pickupAvailabilityHTML.innerHTML;
            })
            .catch(e => {
              console.error(e);
            }); 
        }
      });
    });
  });
  
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xUpdateVariantQuanity', {
        updateQuantity(sectionId, productUrl, currentVariant) {
          const quantity = document.getElementById('x-quantity-' + sectionId);
          if (!quantity) return;
          const url = currentVariant ? `${productUrl}?variant=${currentVariant}&section_id=${sectionId}` :
                        `${productUrl}?section_id=${sectionId}`;
          fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
              let html = new DOMParser().parseFromString(responseText, 'text/html');
              this.render(html, sectionId);
            });
        },
        render(html, sectionId) {
          const destination = document.getElementById('x-quantity-' + sectionId);
          const source = html.getElementById('x-quantity-'+ sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        }
      });
    });
  });
}
